<script lang="ts" setup>
import ConceptView from "@/views/airline_order/grouping/ConceptView.vue";
import Stepper from "@/views/airline_order/Stepper.vue";
definePage({
  meta: {
    action: "read",
    subject: "AirlineOrder",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <Stepper value="group" />
    </VCol>
    <VCol cols="12">
      <ConceptView />
    </VCol>
  </VRow>
</template>
